<button *ngIf="language$ | async as language" class="{{ classes(language) }}"
        [routerLink]="[]"
        [queryParams]="{'lang': language == 'dels' ? 'de' : 'dels'}"
        queryParamsHandling="merge"
        title="Sprache wechseln: Leichte Sprache">
  Leichte Sprache
</button>
